import styled from "styled-components";

import { Paper } from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";

import SearchIcon from "shared-components/icons/search-icon";
import Filter from "shared-components/icons/filter-icon";
import ExportArrowIcon from "shared-components/icons/export-icon";

import {
  COMPONENT_HEADING,
  PARAGRAPH_FONT_SIZE,
} from "constants/style/font-size";
import { PRIMARY_MEDIUM_FONT } from "constants/style/fonts";
import { PRIMARY_LEXUS, WHITE_COLOR } from "constants/style/color";

export const CustomerContainer = styled.div`
  padding: 1.5rem 2rem;
`;

export const Heading = styled.p`
  font-size: ${COMPONENT_HEADING};
  margin: 0;
  font-family: ${PRIMARY_MEDIUM_FONT};
  font-weight: bold;
  user-select: none;
`;

export const ExportToExcel = styled(Paper)`
  display: flex;
  align-items: center;
  padding: 0.8rem 1rem;
  background: ${WHITE_COLOR};
  box-shadow: 0px 4px 18px rgba(0, 0, 0, 0.06) !important;
  border-radius: 10px;
  cursor: pointer !important;
`;

export const FilterDiv = styled(Paper)`
  display: flex;
  align-items: center;
  padding: 0.8rem 1.2rem;
  margin-left: 1rem !important;
  background: ${WHITE_COLOR};
  box-shadow: 0px 4px 18px rgba(0, 0, 0, 0.06) !important;
  border-radius: 10px;
  cursor: pointer;
`;

export const RelativeDiv = styled.div`
  position: relative;
`;

export const InputTextField = styled(TextField)`
  & .MuiOutlinedInput-notchedOutline {
    border-color: ${({ theme }) => theme.color} !important;
  }
  margin-left: 2rem !important;
`;

export const Search = styled(SearchIcon)``;

export const LeftDiv = styled.div`
  display: flex;
`;

export const RightDiv = styled.div`
  display: flex;
`;

export const FilterIcon = styled(Filter)`
  margin-right: 0.6rem;
`;
export const ExportIcon = styled(ExportArrowIcon)`
  cursor: pointer !important;
`;

export const SubHeading = styled.p`
  font-size: ${PARAGRAPH_FONT_SIZE};
  margin: 0;
  color: ${({ theme }) => theme.color};
  font-family: ${PRIMARY_MEDIUM_FONT};
  margin-left: 0.6rem;
`;

export const FilterHeading = styled(SubHeading)`
  color: ${PRIMARY_LEXUS};
  margin-left: 0;
`;

export const HeaderDiv = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ArabicSwitch = styled.div`
  margin-left: 1rem;
  margin-top: 0.5rem;
`;
export const OptionsButton = styled(Button)`
  margin-right: 1rem !important;
  text-transform: none !important;
  height:2.6rem;
`;
